import { useQuery } from "@tanstack/react-query";
import { iriLast } from "../../utils/iriLast";

export function useGetRelatedDatasetsForOffer({ callApiWithWorker, offer }) {
  const related = offer?.related_resource || [];
  const relatedIds = related.map(iriLast).filter(Boolean).sort();

  return useQuery({
    queryKey: ["offerRelatedDatasets", offer?.id, relatedIds.join("|")],
    enabled: !!offer && relatedIds.length > 0,
    queryFn: async ({ signal }) => {
      const datasets = await Promise.all(
        relatedIds.map(async (id) => {
          const res = await callApiWithWorker(`/datasets/${id}`, {
            method: "GET",
            signal,
          });
          const body =
            typeof res?.body === "string"
              ? JSON.parse(res.body)
              : (res?.data ?? res);
          return body;
        }),
      );
      return datasets;
    },
  });
}
